import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shouqi",
  "use": "icon-shouqi-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 8\" fill=\"none\" id=\"icon-shouqi\"><path d=\"M1.5 7.20005L4.652 2.15685C5.04367 1.53018 5.95633 1.53018 6.348 2.15685L9.5 7.20005\" stroke=\"#03C3D7\" stroke-width=\"1.5\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol